import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import static JSON files
import ukTranslation from "locales/uk/translation.json";
import ieTranslation from "locales/ie/translation.json";
import frTranslation from "locales/fr/translation.json";
import ptTranslation from "locales/pt/translation.json";
import auTranslation from "locales/au/translation.json";
import dkTranslation from "locales/dk/translation.json";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            uk: { translation: ukTranslation },
            ie: { translation: ieTranslation },
            fr: { translation: frTranslation },
            pt: { translation: ptTranslation },
            au: { translation: auTranslation },
            dk: { translation: dkTranslation }

        },
        lng: "uk", // default language
        fallbackLng: "uk", // fallback if missing
        supportedLngs: ["uk", "ie", "fr", "pt", "au", "dk"],
        interpolation: {
            escapeValue: false, // React already protects from XSS
        },
    });

export default i18n;
